<template>
  <div>
    <div class="flex flex-row flex-wrap w-full h-full py-52 sm:px-48">
      <div class="loader m-auto"></div>

      <div
        class="
          flex flex-row flex-wrap
          h-auto
          w-full
          m-auto
          justify-center
          mt-space-m
        "
      >
        <p class="m-auto block mt-6 font-medium dark:text-white">
          Please wait while we gather your results...
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Loader",
  data: function () {
    return {};
  },
  methods: {},
};
</script>

<style></style>
